/** Shared vocabulary for the fabric workflow, including spreadsheet headings. */
export const FABRIC_WORKSPACE_ZH = {
    library: '面料库', usage: '款式用料', orders: '面料订购', inventory: '面料库存',
    fabricCode: '面料代码', fabricName: '面料名称', article: '供应商货号', brandCode: '品牌内部编号',
    style: '款号', model: '工艺单编号', batch: '生产批次', version: '版本', season: '年度／季节',
    supplier: '供应商', sourceSupplier: '工艺单供应商', purchaseSupplier: '订购供应商', color: '适用成衣颜色', consumption: '单耗', garmentQty: '款式件数',
    requiredQty: '需求数量', requirementUnit: '需求单位', orderQty: '订购数量',
    price: '单价', currency: '币种', unit: '计价单位', stockUnit: '库存单位',
    delivery: '交货日期', remark: '备注', orderNo: '订购单号', status: '订购状态',
    createdAt: '创建日期', cancelReason: '作废原因', reset: '清空筛选', export: '导出 Excel', refresh: '刷新',
    stockQty: '库存数量', allColors: '全色共通',
};
export const FABRIC_WORKSPACE_KO = {
    library: '원단 라이브러리', usage: '스타일 원단 소요', orders: '원단 발주', inventory: '원단 재고',
    fabricCode: '원단 코드', fabricName: '원단명', article: '공급업체 품번', brandCode: '브랜드 내부 번호',
    style: '스타일 번호', model: '작업지시서 번호', batch: '생산 차수', version: '버전', season: '연도／시즌',
    supplier: '공급업체', sourceSupplier: '작업지시서 공급업체', purchaseSupplier: '발주 공급업체', color: '적용 의류 색상', consumption: '요척', garmentQty: '스타일 수량',
    requiredQty: '소요량', requirementUnit: '소요 단위', orderQty: '발주 수량',
    price: '단가', currency: '통화', unit: '가격 단위', stockUnit: '재고 단위',
    delivery: '납품일', remark: '비고', orderNo: '발주 번호', status: '발주 상태',
    createdAt: '생성일', cancelReason: '취소 사유', reset: '필터 초기화', export: 'Excel 내보내기', refresh: '새로고침',
    stockQty: '재고 수량', allColors: '전 색상 공통',
};
export const FABRIC_PURCHASE_STATUS_ZH = {
    DRAFT: '草稿', ORDERED: '已订购', CANCELLED: '已作废', CREATED: '历史已创建',
    MAILED: '历史已发送', CONFIRMED: '历史已确认', RECEIVED: '历史已收货',
};
export const FABRIC_PURCHASE_STATUS_KO = {
    DRAFT: '초안', ORDERED: '발주 완료', CANCELLED: '취소', CREATED: '과거 생성',
    MAILED: '과거 발송', CONFIRMED: '과거 확인', RECEIVED: '과거 입고',
};
/** Presentation aliases only. Never convert quantities or change stored unit codes. */
export function fabricUnitLabel(unit) {
    const raw = unit?.trim();
    if (!raw)
        return '—';
    return { M: 'm', METER: 'm', METRE: 'm', Y: 'yd', YD: 'yd', YARD: 'yd',
        KG: 'kg', EA: 'EA', PCS: 'EA' }[raw.toUpperCase()] || raw;
}
export function fabricSeasonLabel(year, season) {
    return [year?.trim(), season?.trim()].filter(Boolean).join(' / ') || '—';
}
//# sourceMappingURL=fabric-workspace-display.js.map